module.exports = __webpack_public_path__ + "img/music-test-icon10.6ce54e02.png";